import { render, staticRenderFns } from "./CardInfoJira.vue?vue&type=template&id=41a31c60&scoped=true"
var script = {}
import style0 from "./CardInfoJira.vue?vue&type=style&index=0&id=41a31c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a31c60",
  null
  
)

export default component.exports